export enum
ConstraintType {
    PAX_MIN = 'pax_min', PAX_MAX = 'pax_max', INTL_CHECKED = 'intl_checked'
}
